import { createFileRoute } from '@tanstack/react-router'
import z from 'zod/v3'
import { PlanningAbsenceCalendar } from '~/components/routes/hr/planning/absence-calendar'
import { HrSlotPortal } from '~/components/routes/hr/planning/hr-toolbar-slot'
import { HrStoreSelector } from '~/components/routes/hr/planning/hr-store-selector'
import { ABSENCE_READ } from '~/components/routes/hr/tabs'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/hr/planning/absence-calendar')({
  staticData: {
    permission: ABSENCE_READ,
  },
  component: RouteComponent,
  validateSearch: z.object({
    // Navigation par semaine du calendrier d'absences.
    weekNumber: z.number().optional(),
    year: z.number().optional(),
  }),
})
withRoutePermissions(Route)

function RouteComponent() {
  return (
    <>
      <HrSlotPortal name="toolbar">
        <HrStoreSelector asCta multi={false} />
      </HrSlotPortal>
      <PlanningAbsenceCalendar />
    </>
  )
}
